var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._g({staticClass:"oxy-display-value",class:{
    'is-filled': _vm.isFilled && _vm.applyFillClass,
    'is-inheriting': _vm.isInheriting,
    'is-overwritten': _vm.isOverwritten && _vm.isFilled,
    'is-variable': _vm.isVariable
  }},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }